<template>
  <div>
    <dashboard-page-title @addEvent="$router.push({name: 'addCategory'})" :showFilter="false" :showSearch="false" :showExportation="false">اقسام الأخبار</dashboard-page-title>

    <main-table :fields="fields" :baseURL="VUE_APP_WEBSITE_LINK" :list_url="'admin/categories'"></main-table>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_WEBSITE_LINK } from '@/config/constant'
export default {
  name: 'categories',
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_WEBSITE_LINK,
      fields: [
        { label: 'العنوان', key: 'title', type: 'name', class: 'text-right' },
        {
          label: 'التحكم',
          key: 'actions',
          class: 'text-right',
          type: 'actions',
          actions: [
            {
              text: 'edit',
              icon: 'ri-ball-pen-fill',
              color: 'info',
              ifNavigate: true,
              routePath: 'edit-category/:id'
            },
            {
              text: 'Delete',
              icon: 'ri-delete-bin-line',
              color: 'danger',
              url: 'admin/categories',
              baseUrl: VUE_APP_WEBSITE_LINK,
              titleHeader: 'منتج',
              question: 'هل متأكد أنك تريد مسح هذا العنصر',
              textContent: 'name',
              textDeleteButton: 'بالتأكيد, مسح',
              textCancelButton: 'الغاء',
              showAlert: true
            }
          ]
        }
      ]
    }
  },
  methods: {

  }
}
</script>
